import React, { useEffect, useRef, useState } from "react";
import { toPng } from "html-to-image";

import QRCode from "react-qr-code";
import img from "./img.png";
import khitan from "./khitan.png";
import logo from "./logo-with-text.png";
import "./qr-code.scss";
import { ButtonActionsGlobal } from "../../@component/form/buttons/buttons-actions-global";
import { ButtonRender } from "../../@component/form/buttons/buttons-render";

const ID_DATE_FORMATTER = new Intl.DateTimeFormat("id-ID", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
});

function formatIndonesianDate(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return ID_DATE_FORMATTER.format(date);
}

export default function QrCode({ user, data, theme = "wedding", textTitle = "The Wedding of" }) {
  console.log("theme", theme, textTitle);

  const pageRef = useRef(null);
  const cardRef = useRef(null);
  // const [qrInfo, setQrInfo] = useState({ user });

  const link = window.location.origin + "?tamu=";
  const bgPath = theme === "sunatan" ? khitan : img;

  useEffect(() => {
    const page = pageRef.current;
    if (!page || typeof ResizeObserver === "undefined") return undefined;

    const apply = (width) => {
      const scale = Math.min(0.5, width / 820);
      page.style.setProperty("--qr-scale", String(scale));
    };

    apply(page.clientWidth);
    const ro = new ResizeObserver(([entry]) => apply(entry.contentRect.width));
    ro.observe(page);
    return () => ro.disconnect();
  }, []);

  const clickSend = async () => {
    if (!cardRef.current) return;
    const base64Image = await toPng(cardRef.current, {
      cacheBust: true,
      pixelRatio: 2,
      width: 820,
      height: 920,
      style: {
        transform: "none",
        transformOrigin: "top left",
        margin: "0",
      },
    });
    const link = document.createElement("a");

    link.href = base64Image;
    link.download = "Undangan untuk " + getUser() + ".png";
    link.click();
  };

  const getQR = () => `${link}${getUser()}`;

  const getUser = () => user || "Teman-teman";
  return (
    <div className="qr-code-page" ref={pageRef}>
      <div className="qr-code-stage">
        <div
          ref={cardRef}
          className="qr-code-card wpages"
          style={{
            backgroundImage: `url(${bgPath})`,
          }}
        >
          <div className="qr-code-overlay" />
          <div className="qr-code-content">
            <div className="info">
              <h1>{textTitle}</h1>
              <h2>
                {theme === "wedding" && (
                  <>
                    <span>{data.women.nickname}</span>
                    <span>&</span>
                    <span>{data.man.nickname}</span>
                  </>
                )}
                {theme === "sunatan" && (
                  <>
                    <span>{data.child.fullname}</span>
                  </>
                )}
              </h2>
              <div className="qr-code-row QR">
                <span className="qr-code-greeting">Hi, {getUser()}</span>
                <QRCode value={getQR()} size={235} />
                <div className="logo">
                  <img src={logo} alt="" />
                </div>
              </div>
            </div>
            <div className="dates_">{formatIndonesianDate(data.date)}</div>
          </div>
        </div>
      </div>
      <ButtonActionsGlobal onClick={clickSend} render={() => <ButtonRender>Download Undangan</ButtonRender>} />
    </div>
  );
}
